import {ThunkDispatch} from "@reduxjs/toolkit";
import {useSelector, useDispatch} from 'react-redux'
import { Link } from "react-router-dom";
import LoginHeader from "../components/LoginHeader"
import {ShowPassword, HidePassword, LoadingSpinner} from '../components/Icons'
import {currentUserActions} from '../reducers/currentUser'
import {validateFieldReq, validateEmail} from '../utils/validation'
import TextInput from "./TextInput";
import PasswordInput from "./PasswordInput";
import CustomButton from "./CustomButton";
import LogoHeader from "./LogoHeader";
import { useNavigate } from "react-router-dom"

const LoginGetUsernamePassword = ({view} : {view: 'company' | 'talent'}) => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>()
  const navigate = useNavigate()
  const currentUser = useSelector((state: any) => state.currentUser)
  const {showPassword, error, errors, isLoading} = currentUser
  const resetUrl = view == 'company' ? '/company/reset_password' : '/talent/reset_password'

  const switchShowPassword = () => {
    dispatch(currentUserActions.switchShowPassword())
  }
  const genAuthCodeUser = (event: any) => {
    event.preventDefault();

    if (isLoading) return
    const formData = new FormData(event.target);
    const email = formData.get('email')
    const password = formData.get('password')
    let errors = {} as any
    const validateEmailRes = validateEmail(email)
    if (validateEmailRes != true)
      errors['email'] = validateEmailRes

    const validatePasswordRes = validateFieldReq(password, 'パスワード')
    if (validatePasswordRes != true)
      errors['password'] = validatePasswordRes

    dispatch(currentUserActions.setError(null))
    dispatch(currentUserActions.setErrors(errors))
    if (Object.keys(errors).length != 0) return

    dispatch(currentUserActions.genAuthCodeUser({email, password, view, navigate}))
  };
  return (
    <div className='static md:fixed md:inset-0 bg-alu-base'>
      <div className='min-w-[24.75rem] static md:absolute md:top-1/2 left-1/2 md:transform md:-translate-x-1/2 md:-translate-y-1/2'>
        <LogoHeader view={view} page="advanced"></LogoHeader>
        <div className='bg-white md:rounded-2xl md:shadow-lg md:max-w-[21.4378rem] md:m-auto md:min-h-max min-h-screen w-full py-0 md:py-6'>
          <LoginHeader title="ログイン" logoDirection="row"></LoginHeader>
          <div className="flex flex-col items-center justify-center mt-[3.125rem] md:mt-4 px-4 md:px-6">
            <form onSubmit={genAuthCodeUser} className="bg-white w-full">
              <div className="mb-4">
                <label className="block mb-2 text-sm pointer-events-none" htmlFor="email">
                  メールアドレス
                </label>
                <TextInput
                  error={errors['email']}
                  errorText={errors['email']}
                  id="email"
                  name="email"
                  placeholder="入力してください"
                  onKeyDown={(e) => {}}
                />
              </div>

              <div className="mb-10">
                <label className="block mb-2 text-sm pointer-events-none" htmlFor="password">
                パスワード
                </label>
                <div className='relative'>
                  <PasswordInput
                    error={errors['password'] || error}
                    errorText={errors['password'] || error}
                    id="password"
                    name="password"
                    placeholder="入力してください"
                    onKeyDown={(e) => {}}
                  />
                </div>
              </div>

              <CustomButton type="submit" disabled={isLoading} width="full">
                <p>{isLoading ? "送信中..." : "ログイン"}</p>
                {isLoading && (
                  <span><LoadingSpinner /></span>
                )}
              </CustomButton>
            </form>
            <div className='mt-6 gap-6 flex flex-col px-3 w-full text-center'>
              <p className='inline-flex justify-center items-center'>
                <Link to={resetUrl} className='text-link px-2 py-1 hover:bg-[#fff3e5] rounded text-sm'>
                {view == 'company' ? 'パスワードをお忘れですか？' : 'パスワード登録・再設定'}
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginGetUsernamePassword;
